import { render, staticRenderFns } from "./automation.vue?vue&type=template&id=dbd0be1c&scoped=true"
import script from "./automation.vue?vue&type=script&lang=js"
export * from "./automation.vue?vue&type=script&lang=js"
import style0 from "./automation.vue?vue&type=style&index=0&id=dbd0be1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd0be1c",
  null
  
)

export default component.exports